import ApiService from '@/core/services/api.service';

export const ErrorGroupService = {
  getAll(params = {}) {
    return ApiService.query(`v1/warranty/error-groups`, { params });
  },

  getById(id) {
    return ApiService.get(`v1/warranty/error-groups/${id}`);
  },

  create(data) {
    return ApiService.post('v1/warranty/error-groups', data);
  },

  update(id, data) {
    return ApiService.put(`v1/warranty/error-groups/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/warranty/error-groups/${id}`);
  },

  updateActiveStatus(id, isActive) {
    return ApiService.patch(`v1/warranty/error-groups/${id}/active-status`, {
      isActive,
    });
  },
};
